import { ReactNode } from "react";
import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import { Row } from "@/components/Row";
import { InfoTooltip } from "@/components/form/InfoTooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";

import { cn } from "@/lib/utils";

export const FormSwitchInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  infoTooltip,
  label,
  optional,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  infoTooltip?: string | ReactNode;
  label: string;
  optional?: boolean;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel className="inline-flex items-center gap-1">
              {label}
              {infoTooltip && <InfoTooltip content={infoTooltip} />}
              {optional && <OptionalLabel className="ml-1.5" />}
            </FormLabel>
            <FormControl>
              {/* Match shadcn Input's control height so switch aligns nicely in flex Rows */}
              <Row className="h-10 items-center">
                <Switch
                  checked={!!field.value}
                  onCheckedChange={field.onChange}
                />
              </Row>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
